import { ChatMessageData } from "@twiliointernal/e2-commons-shared-definitions";
import { DateTime } from "@twiliointernal/e2-commons-shared-utils";
import { types } from "../definitions";

const sortChatMessagesByRelativeTime = (
  chatMessages: ChatMessageData[],
  formatTimePastYesterday?: string
): types.SortChatMessagesByRelativeTimeReturn =>
  chatMessages.reduce(
    (
      accum: types.SortChatMessagesByRelativeTimeReturn,
      message: ChatMessageData
    ) => {
      const dateTime = new DateTime(message.createdAt);
      let timeKey = dateTime.getRelativeTimeFromToday();

      // for timeKeys beyond Today and Yesterday, use provided time format as timekey
      if (formatTimePastYesterday) {
        timeKey =
          timeKey === "Today" || timeKey === "Yesterday"
            ? timeKey
            : dateTime.format(formatTimePastYesterday);
      }

      if (accum[timeKey]) {
        accum[timeKey].push(message);
        return accum;
      }
      accum[timeKey] = [message];
      return accum;
    },
    {}
  );

export default sortChatMessagesByRelativeTime;
